import { render, staticRenderFns } from "./MdKpiCard.vue?vue&type=template&id=608eba6a&scoped=true&"
import script from "./MdKpiCard.vue?vue&type=script&lang=js&"
export * from "./MdKpiCard.vue?vue&type=script&lang=js&"
import style0 from "./MdKpiCard.vue?vue&type=style&index=0&id=608eba6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608eba6a",
  null
  
)

export default component.exports